import { convertStringToAlphanumeric } from '@fourthwall/utils/dist/string';
import capitalize from 'lodash-es/capitalize';
const webhookLabels = {
    PRODUCT_CREATED: 'Product (offer) created',
    PRODUCT_UPDATED: 'Product (offer) updated',
};
export const getWebhookTypeLabel = (webhookType) => webhookLabels[webhookType] ?? capitalize(convertStringToAlphanumeric(webhookType));
